import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-tables',
  templateUrl: './admin-tables.component.html',
  styleUrls: ['./admin-tables.component.css']  
})
export class AdminTablesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
